import { registerIntegration } from "@p0security/shared/integrations/registry";
import { Registration } from "@p0security/shared/integrations/types";
import { omit } from "lodash-es";

import { newScimAccesses, newScimFilters } from "../scim/accesses.ts";
import { CloudflareComponents } from "./components.ts";

const label = "Cloudflare";

const scimArgs = {
  entitlement: { label: "N/A" },
  group: { label: "Role", description: "Cloudflare account role" },
  locator: {
    label: "Account",
    description: "Cloudflare account identifier",
  },
  name: label,
};

const accesses = omit(newScimAccesses(scimArgs), "entitlement");
const filters = omit(newScimFilters(scimArgs), "entitlement");

export const CloudflareRegistration = Registration({
  accesses,
  category: "resource",
  components: CloudflareComponents,
  docs: {},
  filters,
  itemKind: "account",
  label,
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/9/94/Cloudflare_Logo.png",
  maturity: "preview",
  useMapping: [{ use: "iam_write", component: "scim" }],
  requestType: "requestable",
});

registerIntegration("cloudflare", CloudflareRegistration);
